/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {BatchEditHarvests} from '../bioplanModels';
// @ts-ignore
import type {CreateHarvest} from '../bioplanModels';
// @ts-ignore
import type {CreateHarvestSequence} from '../bioplanModels';
// @ts-ignore
import type {Harvest} from '../bioplanModels';
// @ts-ignore
import type {HarvestOverview} from '../bioplanModels';
// @ts-ignore
import type {HarvestWithDistributions} from '../bioplanModels';
// @ts-ignore
import type {PatchHarvest} from '../bioplanModels';
/**
 * PlanningHarvestApi - axios parameter creator
 * @export
 */
export const PlanningHarvestApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create harvest sequence for a cage
     * @param {CreateHarvestSequence} createHarvestSequence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestSequencePost: async (
      createHarvestSequence: CreateHarvestSequence,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createHarvestSequence' is not null or undefined
      assertParamExists('harvestSequencePost', 'createHarvestSequence', createHarvestSequence);
      const localVarPath = `/harvestSequence`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(createHarvestSequence, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} cageId
     * @param {BatchEditHarvests} batchEditHarvests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsBulkCageIdPatch: async (
      cageId: string,
      batchEditHarvests: BatchEditHarvests,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('harvestsBulkCageIdPatch', 'cageId', cageId);
      // verify required parameter 'batchEditHarvests' is not null or undefined
      assertParamExists('harvestsBulkCageIdPatch', 'batchEditHarvests', batchEditHarvests);
      const localVarPath = `/harvests/bulk/{cageId}`.replace(`{${'cageId'}}`, encodeURIComponent(String(cageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(batchEditHarvests, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all harvest actions for a cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsGet: async (
      cageId?: string,
      siteId?: string,
      planId?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/harvests/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete harvest by its identifier
     * @param {string} harvestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdDelete: async (harvestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'harvestId' is not null or undefined
      assertParamExists('harvestsHarvestIdDelete', 'harvestId', harvestId);
      const localVarPath = `/harvests/{harvestId}`.replace(`{${'harvestId'}}`, encodeURIComponent(String(harvestId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get harvest by its identifier
     * @param {string} harvestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdGet: async (harvestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'harvestId' is not null or undefined
      assertParamExists('harvestsHarvestIdGet', 'harvestId', harvestId);
      const localVarPath = `/harvests/{harvestId}`.replace(`{${'harvestId'}}`, encodeURIComponent(String(harvestId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Partial update harvest for a cage
     * @param {string} harvestId
     * @param {PatchHarvest} patchHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdPatch: async (
      harvestId: string,
      patchHarvest: PatchHarvest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestId' is not null or undefined
      assertParamExists('harvestsHarvestIdPatch', 'harvestId', harvestId);
      // verify required parameter 'patchHarvest' is not null or undefined
      assertParamExists('harvestsHarvestIdPatch', 'patchHarvest', patchHarvest);
      const localVarPath = `/harvests/{harvestId}`.replace(`{${'harvestId'}}`, encodeURIComponent(String(harvestId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(patchHarvest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update harvest for a cage
     * @param {string} harvestId
     * @param {CreateHarvest} createHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdPut: async (
      harvestId: string,
      createHarvest: CreateHarvest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestId' is not null or undefined
      assertParamExists('harvestsHarvestIdPut', 'harvestId', harvestId);
      // verify required parameter 'createHarvest' is not null or undefined
      assertParamExists('harvestsHarvestIdPut', 'createHarvest', createHarvest);
      const localVarPath = `/harvests/{harvestId}`.replace(`{${'harvestId'}}`, encodeURIComponent(String(harvestId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(createHarvest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get quality distribution of a harvest by its identifier
     * @param {string} harvestId
     * @param {boolean} hogWeight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdQualityDistributionGet: async (
      harvestId: string,
      hogWeight: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestId' is not null or undefined
      assertParamExists('harvestsHarvestIdQualityDistributionGet', 'harvestId', harvestId);
      // verify required parameter 'hogWeight' is not null or undefined
      assertParamExists('harvestsHarvestIdQualityDistributionGet', 'hogWeight', hogWeight);
      const localVarPath = `/harvests/{harvestId}/qualityDistribution`.replace(
        `{${'harvestId'}}`,
        encodeURIComponent(String(harvestId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (hogWeight !== undefined) {
        localVarQueryParameter['hogWeight'] = hogWeight;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all harvest actions for multiple plans
     * @param {Array<string>} planIds
     * @param {boolean} hogWeight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsOverviewGet: async (
      planIds: Array<string>,
      hogWeight: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planIds' is not null or undefined
      assertParamExists('harvestsOverviewGet', 'planIds', planIds);
      // verify required parameter 'hogWeight' is not null or undefined
      assertParamExists('harvestsOverviewGet', 'hogWeight', hogWeight);
      const localVarPath = `/harvestsOverview`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planIds) {
        localVarQueryParameter['planIds'] = planIds;
      }

      if (hogWeight !== undefined) {
        localVarQueryParameter['hogWeight'] = hogWeight;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create harvest for a cage
     * @param {CreateHarvest} createHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsPost: async (createHarvest: CreateHarvest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'createHarvest' is not null or undefined
      assertParamExists('harvestsPost', 'createHarvest', createHarvest);
      const localVarPath = `/harvests/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(createHarvest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsUnassignedPlanIdAssignPut: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestsUnassignedPlanIdAssignPut', 'planId', planId);
      const localVarPath = `/harvests/unassigned/{planId}/assign`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsUnassignedPlanIdGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestsUnassignedPlanIdGet', 'planId', planId);
      const localVarPath = `/harvests/unassigned/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningHarvestApi - functional programming interface
 * @export
 */
export const PlanningHarvestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningHarvestApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create harvest sequence for a cage
     * @param {CreateHarvestSequence} createHarvestSequence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestSequencePost(
      createHarvestSequence: CreateHarvestSequence,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Harvest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestSequencePost(createHarvestSequence, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestSequencePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} cageId
     * @param {BatchEditHarvests} batchEditHarvests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsBulkCageIdPatch(
      cageId: string,
      batchEditHarvests: BatchEditHarvests,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Harvest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsBulkCageIdPatch(
        cageId,
        batchEditHarvests,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsBulkCageIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all harvest actions for a cage
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsGet(
      cageId?: string,
      siteId?: string,
      planId?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Harvest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsGet(
        cageId,
        siteId,
        planId,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete harvest by its identifier
     * @param {string} harvestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsHarvestIdDelete(
      harvestId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsHarvestIdDelete(harvestId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsHarvestIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get harvest by its identifier
     * @param {string} harvestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsHarvestIdGet(
      harvestId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Harvest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsHarvestIdGet(harvestId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsHarvestIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Partial update harvest for a cage
     * @param {string} harvestId
     * @param {PatchHarvest} patchHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsHarvestIdPatch(
      harvestId: string,
      patchHarvest: PatchHarvest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Harvest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsHarvestIdPatch(
        harvestId,
        patchHarvest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsHarvestIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update harvest for a cage
     * @param {string} harvestId
     * @param {CreateHarvest} createHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsHarvestIdPut(
      harvestId: string,
      createHarvest: CreateHarvest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Harvest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsHarvestIdPut(harvestId, createHarvest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsHarvestIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get quality distribution of a harvest by its identifier
     * @param {string} harvestId
     * @param {boolean} hogWeight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsHarvestIdQualityDistributionGet(
      harvestId: string,
      hogWeight: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestWithDistributions>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsHarvestIdQualityDistributionGet(
        harvestId,
        hogWeight,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsHarvestIdQualityDistributionGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all harvest actions for multiple plans
     * @param {Array<string>} planIds
     * @param {boolean} hogWeight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsOverviewGet(
      planIds: Array<string>,
      hogWeight: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestOverview>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsOverviewGet(planIds, hogWeight, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsOverviewGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create harvest for a cage
     * @param {CreateHarvest} createHarvest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsPost(
      createHarvest: CreateHarvest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Harvest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsPost(createHarvest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsUnassignedPlanIdAssignPut(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsUnassignedPlanIdAssignPut(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsUnassignedPlanIdAssignPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestsUnassignedPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Harvest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestsUnassignedPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestApi.harvestsUnassignedPlanIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningHarvestApi - factory interface
 * @export
 */
export const PlanningHarvestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningHarvestApiFp(configuration);
  return {
    /**
     *
     * @summary Create harvest sequence for a cage
     * @param {PlanningHarvestApiHarvestSequencePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestSequencePost(
      requestParameters: PlanningHarvestApiHarvestSequencePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Harvest>> {
      return localVarFp
        .harvestSequencePost(requestParameters.createHarvestSequence, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningHarvestApiHarvestsBulkCageIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsBulkCageIdPatch(
      requestParameters: PlanningHarvestApiHarvestsBulkCageIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Harvest>> {
      return localVarFp
        .harvestsBulkCageIdPatch(requestParameters.cageId, requestParameters.batchEditHarvests, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all harvest actions for a cage
     * @param {PlanningHarvestApiHarvestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsGet(
      requestParameters: PlanningHarvestApiHarvestsGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Harvest>> {
      return localVarFp
        .harvestsGet(
          requestParameters.cageId,
          requestParameters.siteId,
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete harvest by its identifier
     * @param {PlanningHarvestApiHarvestsHarvestIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdDelete(
      requestParameters: PlanningHarvestApiHarvestsHarvestIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .harvestsHarvestIdDelete(requestParameters.harvestId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get harvest by its identifier
     * @param {PlanningHarvestApiHarvestsHarvestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdGet(
      requestParameters: PlanningHarvestApiHarvestsHarvestIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Harvest> {
      return localVarFp
        .harvestsHarvestIdGet(requestParameters.harvestId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Partial update harvest for a cage
     * @param {PlanningHarvestApiHarvestsHarvestIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdPatch(
      requestParameters: PlanningHarvestApiHarvestsHarvestIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Harvest> {
      return localVarFp
        .harvestsHarvestIdPatch(requestParameters.harvestId, requestParameters.patchHarvest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update harvest for a cage
     * @param {PlanningHarvestApiHarvestsHarvestIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdPut(
      requestParameters: PlanningHarvestApiHarvestsHarvestIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Harvest> {
      return localVarFp
        .harvestsHarvestIdPut(requestParameters.harvestId, requestParameters.createHarvest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get quality distribution of a harvest by its identifier
     * @param {PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsHarvestIdQualityDistributionGet(
      requestParameters: PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestWithDistributions> {
      return localVarFp
        .harvestsHarvestIdQualityDistributionGet(requestParameters.harvestId, requestParameters.hogWeight, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all harvest actions for multiple plans
     * @param {PlanningHarvestApiHarvestsOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsOverviewGet(
      requestParameters: PlanningHarvestApiHarvestsOverviewGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestOverview>> {
      return localVarFp
        .harvestsOverviewGet(requestParameters.planIds, requestParameters.hogWeight, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create harvest for a cage
     * @param {PlanningHarvestApiHarvestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsPost(
      requestParameters: PlanningHarvestApiHarvestsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Harvest> {
      return localVarFp
        .harvestsPost(requestParameters.createHarvest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsUnassignedPlanIdAssignPut(
      requestParameters: PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .harvestsUnassignedPlanIdAssignPut(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestsUnassignedPlanIdGet(
      requestParameters: PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Harvest>> {
      return localVarFp
        .harvestsUnassignedPlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for harvestSequencePost operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestSequencePostRequest
 */
export interface PlanningHarvestApiHarvestSequencePostRequest {
  /**
   *
   * @type {CreateHarvestSequence}
   * @memberof PlanningHarvestApiHarvestSequencePost
   */
  readonly createHarvestSequence: CreateHarvestSequence;
}

/**
 * Request parameters for harvestsBulkCageIdPatch operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsBulkCageIdPatchRequest
 */
export interface PlanningHarvestApiHarvestsBulkCageIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsBulkCageIdPatch
   */
  readonly cageId: string;

  /**
   *
   * @type {BatchEditHarvests}
   * @memberof PlanningHarvestApiHarvestsBulkCageIdPatch
   */
  readonly batchEditHarvests: BatchEditHarvests;
}

/**
 * Request parameters for harvestsGet operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsGetRequest
 */
export interface PlanningHarvestApiHarvestsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsGet
   */
  readonly siteId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsGet
   */
  readonly planId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for harvestsHarvestIdDelete operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsHarvestIdDeleteRequest
 */
export interface PlanningHarvestApiHarvestsHarvestIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsHarvestIdDelete
   */
  readonly harvestId: string;
}

/**
 * Request parameters for harvestsHarvestIdGet operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsHarvestIdGetRequest
 */
export interface PlanningHarvestApiHarvestsHarvestIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsHarvestIdGet
   */
  readonly harvestId: string;
}

/**
 * Request parameters for harvestsHarvestIdPatch operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsHarvestIdPatchRequest
 */
export interface PlanningHarvestApiHarvestsHarvestIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsHarvestIdPatch
   */
  readonly harvestId: string;

  /**
   *
   * @type {PatchHarvest}
   * @memberof PlanningHarvestApiHarvestsHarvestIdPatch
   */
  readonly patchHarvest: PatchHarvest;
}

/**
 * Request parameters for harvestsHarvestIdPut operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsHarvestIdPutRequest
 */
export interface PlanningHarvestApiHarvestsHarvestIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsHarvestIdPut
   */
  readonly harvestId: string;

  /**
   *
   * @type {CreateHarvest}
   * @memberof PlanningHarvestApiHarvestsHarvestIdPut
   */
  readonly createHarvest: CreateHarvest;
}

/**
 * Request parameters for harvestsHarvestIdQualityDistributionGet operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest
 */
export interface PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsHarvestIdQualityDistributionGet
   */
  readonly harvestId: string;

  /**
   *
   * @type {boolean}
   * @memberof PlanningHarvestApiHarvestsHarvestIdQualityDistributionGet
   */
  readonly hogWeight: boolean;
}

/**
 * Request parameters for harvestsOverviewGet operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsOverviewGetRequest
 */
export interface PlanningHarvestApiHarvestsOverviewGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningHarvestApiHarvestsOverviewGet
   */
  readonly planIds: Array<string>;

  /**
   *
   * @type {boolean}
   * @memberof PlanningHarvestApiHarvestsOverviewGet
   */
  readonly hogWeight: boolean;
}

/**
 * Request parameters for harvestsPost operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsPostRequest
 */
export interface PlanningHarvestApiHarvestsPostRequest {
  /**
   *
   * @type {CreateHarvest}
   * @memberof PlanningHarvestApiHarvestsPost
   */
  readonly createHarvest: CreateHarvest;
}

/**
 * Request parameters for harvestsUnassignedPlanIdAssignPut operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest
 */
export interface PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsUnassignedPlanIdAssignPut
   */
  readonly planId: string;
}

/**
 * Request parameters for harvestsUnassignedPlanIdGet operation in PlanningHarvestApi.
 * @export
 * @interface PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest
 */
export interface PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestApiHarvestsUnassignedPlanIdGet
   */
  readonly planId: string;
}

/**
 * PlanningHarvestApi - object-oriented interface
 * @export
 * @class PlanningHarvestApi
 * @extends {BaseAPI}
 */
export class PlanningHarvestApi extends BaseAPI {
  /**
   *
   * @summary Create harvest sequence for a cage
   * @param {PlanningHarvestApiHarvestSequencePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestSequencePost(
    requestParameters: PlanningHarvestApiHarvestSequencePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestSequencePost(requestParameters.createHarvestSequence, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningHarvestApiHarvestsBulkCageIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsBulkCageIdPatch(
    requestParameters: PlanningHarvestApiHarvestsBulkCageIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsBulkCageIdPatch(requestParameters.cageId, requestParameters.batchEditHarvests, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all harvest actions for a cage
   * @param {PlanningHarvestApiHarvestsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsGet(requestParameters: PlanningHarvestApiHarvestsGetRequest = {}, options?: RawAxiosRequestConfig) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsGet(
        requestParameters.cageId,
        requestParameters.siteId,
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete harvest by its identifier
   * @param {PlanningHarvestApiHarvestsHarvestIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsHarvestIdDelete(
    requestParameters: PlanningHarvestApiHarvestsHarvestIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsHarvestIdDelete(requestParameters.harvestId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get harvest by its identifier
   * @param {PlanningHarvestApiHarvestsHarvestIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsHarvestIdGet(
    requestParameters: PlanningHarvestApiHarvestsHarvestIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsHarvestIdGet(requestParameters.harvestId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Partial update harvest for a cage
   * @param {PlanningHarvestApiHarvestsHarvestIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsHarvestIdPatch(
    requestParameters: PlanningHarvestApiHarvestsHarvestIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsHarvestIdPatch(requestParameters.harvestId, requestParameters.patchHarvest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update harvest for a cage
   * @param {PlanningHarvestApiHarvestsHarvestIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsHarvestIdPut(
    requestParameters: PlanningHarvestApiHarvestsHarvestIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsHarvestIdPut(requestParameters.harvestId, requestParameters.createHarvest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get quality distribution of a harvest by its identifier
   * @param {PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsHarvestIdQualityDistributionGet(
    requestParameters: PlanningHarvestApiHarvestsHarvestIdQualityDistributionGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsHarvestIdQualityDistributionGet(requestParameters.harvestId, requestParameters.hogWeight, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all harvest actions for multiple plans
   * @param {PlanningHarvestApiHarvestsOverviewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsOverviewGet(
    requestParameters: PlanningHarvestApiHarvestsOverviewGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsOverviewGet(requestParameters.planIds, requestParameters.hogWeight, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create harvest for a cage
   * @param {PlanningHarvestApiHarvestsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsPost(requestParameters: PlanningHarvestApiHarvestsPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsPost(requestParameters.createHarvest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get cages with unallocated biomass
   * @param {PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsUnassignedPlanIdAssignPut(
    requestParameters: PlanningHarvestApiHarvestsUnassignedPlanIdAssignPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsUnassignedPlanIdAssignPut(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get cages with unallocated biomass
   * @param {PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestApi
   */
  public harvestsUnassignedPlanIdGet(
    requestParameters: PlanningHarvestApiHarvestsUnassignedPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestApiFp(this.configuration)
      .harvestsUnassignedPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
